import { Outlet } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";

const Layout = () => {
    return (
        <div className="font-display flex flex-col min-h-screen relative">
            <Header />
            <Outlet />
            <Footer />
        </div>
    );
};

export default Layout;
